import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store'
/**
 * The initializer NGRX action
 */
export const INIT_SCREEN = '[Parameters searchSecurityPortfolioMenu] Init'
/**
 * The destroy NGRX action
 */
export const DESTROY_SCREEN = '[Parameters searchSecurityPortfolioMenu] Destroy'

export const CANCEL = '[Parameters searchSecurityPortfolioMenu] Cancel'
export const CANCEL_SUCCESS =
  '[Parameters searchSecurityPortfolioMenu] Cancel Success'
export const CANCEL_FAIL =
  '[Parameters searchSecurityPortfolioMenu] Cancel Fail'

export const SELECT = '[Parameters searchSecurityPortfolioMenu] Select'
export const SELECT_SUCCESS =
  '[Parameters searchSecurityPortfolioMenu] Select Success'
export const SELECT_FAIL =
  '[Parameters searchSecurityPortfolioMenu] Select Fail'

/**
 * Action identifier of the search result count
 */
export const COUNT = '[Parameters searchSecurityPortfolioMenu] Count'
/**
 * Action identifier of the success execution of the `COUNT` action
 */
export const COUNT_SUCCESS =
  '[Parameters searchSecurityPortfolioMenu] Count Success'
/**
 * Action identifier of the fail execution of the `COUNT` action
 */
export const COUNT_FAIL = '[Parameters searchSecurityPortfolioMenu] Count Fail'
/**
 * Action identifier of the search result action
 */
export const SEARCH = '[Parameters searchSecurityPortfolioMenu] Search'
/**
 * Action identifier of the success execution of the `SEARCH` action
 */
export const SEARCH_SUCCESS =
  '[Parameters searchSecurityPortfolioMenu] Search Success'
/**
 * Action identifier of the fail execution of the `SEARCH` action
 */
export const SEARCH_FAIL =
  '[Parameters searchSecurityPortfolioMenu] Search Fail'
/**
 * Action identifier to store the selected rows in the state
 */
export const ROWS_SELECTION_CHANGE =
  '[Parameters searchSecurityPortfolioMenu] Rows Selection Change'

export const initAction = ngrxCreateAction(INIT_SCREEN, (payload) => payload)

export const destroyAction = ngrxCreateAction(
  DESTROY_SCREEN,
  (payload) => payload
)

/**
 * The Cancel NGRX action
 */
export const cancelAction = ngrxCreateAction(CANCEL, (payload) => payload)
/**
 * The Cancel success NGRX action
 */
export const cancelSuccessAction = ngrxCreateAction(
  CANCEL_SUCCESS,
  (payload) => payload
)
/**
 * The Cancel fail NGRX action
 */
export const cancelFailAction = ngrxCreateAction(
  CANCEL_FAIL,
  (payload) => payload
)
/**
 * The Select NGRX action
 */
export const selectAction = ngrxCreateAction(SELECT, (payload) => payload)
/**
 * The Select success NGRX action
 */
export const selectSuccessAction = ngrxCreateAction(
  SELECT_SUCCESS,
  (payload) => payload
)
/**
 * The Select fail NGRX action
 */
export const selectFailAction = ngrxCreateAction(
  SELECT_FAIL,
  (payload) => payload
)

/**
 * NGRX Action of the search result count
 */
export const countAction = ngrxCreateAction(COUNT, (payload) => payload)
/**
 * NGRX Action of the success execution of the `countAction` action
 */
export const countSuccessAction = ngrxCreateAction(
  COUNT_SUCCESS,
  (payload) => payload
)
/**
 * NGRX Action of the fail execution of the `countAction` action
 */
export const countFailAction = ngrxCreateAction(
  COUNT_FAIL,
  (payload) => payload
)
/**
 * NGRX Action of the search result action
 */
export const searchAction = ngrxCreateAction(SEARCH, (payload) => payload)
/**
 * NGRX Action of the success execution of the `searchAction` action
 */
export const searchSuccessAction = ngrxCreateAction(
  SEARCH_SUCCESS,
  (payload) => payload
)
/**
 * NGRX Action of the fail execution of the `searchAction` action
 */
export const searchFailAction = ngrxCreateAction(
  SEARCH_FAIL,
  (payload) => payload
)
/**
 * NGRX Action to store a relation item client-side
 */
export const rowsSelectionChangeAction = ngrxCreateAction(
  ROWS_SELECTION_CHANGE,
  (payload) => payload
)
